export default __webpack_public_path__ + "static/media/breakfast-overlay@2x.0e643244.png";